"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeFirstEmitted = void 0;
const operators_1 = require("rxjs/operators");
function takeFirstEmitted(observable) {
    return new Promise((resolve, reject) => {
        observable.pipe((0, operators_1.take)(1)).subscribe((x) => resolve(x), err => reject(err));
    });
}
exports.takeFirstEmitted = takeFirstEmitted;
//# sourceMappingURL=take_first_emitted.js.map